<template>
  <el-menu background-color="#9B8B1C" text-color="#fff" :default-active="activeIndex" class="el-menu-middle moblie-menu" mode="horizontal" router>
      <el-menu-item v-for="(item, index) in menuArr" :key="index" :index="item.path"><span>{{item.name}}</span></el-menu-item>
  </el-menu>
</template>

<script>
import router from '../router/index.js';
export default {
  data() {
    return {
      menuArr:[
        {
          name: '首页',
          path: '/'
        },
        {
          name: '大会',
          path: '/conference',
        },
        {
          name: '云展',
          path: '/exhibition',
        },
        {
          name: '活动',
          path: '/active',
        },
        // {
        //   name: '商机',
        //   path: '/business',
        // },
        {
          name: '新闻',
          path: '/news',
        },
        {
          name: '我的',
          path: '/mine',
        },
      ]
    };
  },
  created() {
    localStorage.getItem("languageSet");
  },
  mounted() {
    this.navDefalut();
  },
  computed: {
    getActive:function(){
      var path = this.$router.path.split("/");
      return path;
    },
    activeIndex() {
      const { name } = this.$route;
      console.log(name)
      var rout=''
      switch (name) {
        case 'home':
          rout = '';
        case 'guestmessage':
          rout = '/';
        case 'guestDetail':
          rout = '/';
        case 'conference':
          rout = '/conference';
        case 'exhibition':
          rout = '/exhibition';
        case 'product':
          rout = '/exhibition';
        case 'prodetail':
          rout = '/exhibition';
        case 'exhibitorDetail':
          rout = '/exhibition';
        case 'exhibitor':
          rout = '/exhibition';
        case 'active':
          rout = '/active';
        case 'activelist':
          rout = '/active';
        case 'activedetail':
          rout = '/active';
        case 'business':
          rout = '/business';
        case 'international':
          rout = '/business';
        case 'news':
          rout = '/news';
        case 'newsdetails':
          rout = '/news';
        case 'mine':
          rout = '/mine';
        case 'dataEdit':
          rout = '/mine';
        case 'feedback':
          rout = '/mine';
        case 'myproduct':
          rout = '/mine';
        case 'mycompany':
          rout = '/mine';
        case 'myactive':
          rout = '/mine';
        case 'demandissue':
          rout = '/mine';
        case 'myresponse':
          rout = '/mine';
        case 'mymessage':
          rout = '/mine';
        case 'inbox':
          rout = '/mine';
      }
      return rout;
    }
  },
  methods: {
    navDefalut(){
      this.menuArr.forEach(item => {
          if(item.name == '首页'){
            item.name = this.$t('navMenu.home');
          }else if(item.name == '大会'){
            item.name = this.$t('navMenu.conference');
          }else if(item.name == '云展'){
            item.name = this.$t('navMenu.exhibition');
          }else if(item.name == '活动'){
            item.name = this.$t('navMenu.active');
          }else if(item.name == '商机'){
            item.name = this.$t('navMenu.business');
          }else if(item.name == '新闻'){
            item.name = this.$t('navMenu.news');
          }else if(item.name == '我的'){
            item.name = this.$t('navMenu.mine');
          }
      });
      this.menuArr = this.menuArr;
    }
  }
}
</script>

<style lang="scss" scoped>
.el-menu{width:100%;height: 100%;display: flex;padding: 0 20px;box-sizing: border-box;align-items: center;background:#CAC28A;}
.el-menu-item{font-size: 18px;height: 100%;line-height: 25px;flex:1;text-align: center;display: flex;align-items: center;justify-content: center;}
.el-menu.el-menu--horizontal,.el-menu--horizontal>.el-menu-item{border-bottom: 0 none;}
.el-menu--horizontal>.el-menu-item.is-active{border-bottom-color: transparent;color: #fff;}
.el-menu--horizontal > .el-menu-item.is-active{background-color: #9B8B1C !important;}
.el-menu-middle .el-menu-item,.el-menu-middle .el-submenu__title{white-space: normal;}
@media only screen and (max-width: 767px){
  .el-menu{position: absolute;width: 100%;}
}
</style>